import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { Button, Inline } from 'chaoskit/src/components';

import BaseLayout from './BaseLayout';
import Hero from '../partials/Hero';
import { Icon, Link, Subnav } from '../components';
import SocialGroup from '../partials/global/SocialGroup';

const Press = props => (
  <StaticQuery
    query={graphql`
      query PressPageData {
        file(name: { eq: "footer" }) {
          childDataYaml {
            social {
              title
              service
              url
            }
          }
        }
      }
    `}
    render={data => {
      const {
        file: { childDataYaml: pageData },
      } = data;
      const { children } = props;

      return (
        <BaseLayout>
          <Hero compact className="u-gradient--teal-darkBlue">
            <div className="hero-content">
              <div className="container">
                <div className="hero-titleWrapper">
                  <h1 className="hero-title">About Gremlin</h1>
                  <p className="hero-titleSub">
                    News, company info, and media resources
                  </p>

                  <Button
                    url="mailto:adam@gremlin.com"
                    type="default"
                    className="u-mt--large"
                  >
                    <Icon icon="email" className="u-mr--small" />
                    adam@gremlin.com
                  </Button>
                </div>
              </div>
            </div>
          </Hero>
          <Subnav>
            <div>
              <Inline wrap={false} size="large" className="subnav-nav">
                <Link to="/press/about/">About Us</Link>
                <Link to="/press/media/">Media Coverage</Link>
                <Link to="/press/kit/">Logos &amp; Press Kit</Link>
              </Inline>
            </div>
            <div>
              <SocialGroup
                wrap={false}
                className="press__nav-social"
                networks={pageData.social}
              />
            </div>
          </Subnav>
          {children}
        </BaseLayout>
      );
    }}
  />
);

Press.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Press;
